import Paginate from 'vuejs-paginate';

export const pagination = {
  data() {
    return {
      paginate: {
        perPage: 10,
        page: 1,
        forcePage: 0,
        lastPage: 0,
        pageRange: 3,
        marginPages: 2,
      },
    };
  },
  components: {
    Paginate
  },
  methods: {
    setPaginate: function(data) {
      this.paginate.perPage = data.perPage;
      this.paginate.page = data.currentPage;
      this.paginate.lastPage = data.lastPage;
    },

    onPaginationBtnClick: async function(pageNum) {
      this.paginate.page = pageNum;
      this.paginate.forcePage = pageNum - 1;
    },
  }
}



// WEBPACK FOOTER //
// ./src/common/mixins/pagination.js